// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + "a2d5e7f3bdfd18a9bb18" + ".js");